import React from 'react'
import { Typography, Stack, Box, useTheme, useMediaQuery } from '@mui/material'
import { DynamicPriceIcon } from '../../shared/icons/DynamicPriceIcon'
import { StaticPriceIcon } from '../../shared/icons/SaticPriceIcon'
import { TariffCategory } from '../../shared/models/types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface TariffCategoryCellProps {
  category: TariffCategory
}

/**
 *  Tariffs category cell component used inside ich row in tariffs table.
 *  @param status - one of types from TariffCategory
 */
export const TariffCategoryCell: React.VFC<TariffCategoryCellProps> = ({ category }) => {
  const { t } = useCustomTranslation()

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Stack flexDirection={'row'} alignItems="center" gap={1}>
      <Box mb={0.5}>{category === TariffCategory.dynamicTariff ? <DynamicPriceIcon /> : <StaticPriceIcon />}</Box>
      <Typography fontSize={isMobile ? 14 : 16} mt={isMobile ? 0.5 : 0}>
        {t(`emobility.tariffs.tariff-category-${category}`)}
      </Typography>
    </Stack>
  )
}
